import * as React from 'react';
import type { CardPrimaryLayoutProps } from '../../card-primary-layout/card-primary-layout';
import { CardPrimaryLayout } from '../../card-primary-layout/card-primary-layout';
import { DropdownButton } from '@components/molecules'; // Adjust the import based on your folder structure
import type { CollapseButtonComponentProps } from '@components/molecules';

interface CollapsibleCardProps extends React.HTMLAttributes<HTMLDivElement>, CardPrimaryLayoutProps {
	title: string;
	isCollapsed: boolean;
	toggleCollapse?: () => void;
	CollapseButtonComponent?: CollapseButtonComponentProps;
}

export const CollapsibleCard: React.FC<CollapsibleCardProps> = ({
	title,
	isCollapsed = false,
	toggleCollapse,
	ariaControls,
	isDisabled = false,
	CollapseButtonComponent: CollapseButton = DropdownButton,
	headerSubComponent,
	children,
	'aria-label': ariaLabel = 'collapisable-card',
	TitleComponent,
	headerClassName,
	className,
	withBorder,
	keepContentMounted,
}) => {
	return (
		<CardPrimaryLayout
			title={title}
			isCollapsed={isCollapsed}
			TitleComponent={TitleComponent}
			className={className}
			headerButtons={
				<CollapseButton
					isActive={isCollapsed}
					ariaControls={ariaControls}
					disabled={isDisabled}
					ariaLabelledBy={ariaLabel}
				/>
			}
			headerSubComponent={headerSubComponent}
			ariaControls={ariaControls}
			isDisabled={isDisabled}
			aria-label={ariaLabel}
			onHeaderClick={isDisabled ? undefined : toggleCollapse}
			headerClassName={headerClassName}
			withBorder={withBorder}
			keepContentMounted={keepContentMounted}
		>
			{children}
		</CardPrimaryLayout>
	);
};
